module.exports = new __parcel__URL__("Mageskill_33.768c213a.png").toString();